// Default responsibility carried by every executive/support role for
// succession planning. The predefined default roles (President/Treasurer/
// Secretary) already list it among their duties; any other (user-created) role
// falls back to this single default. It is display-only and cannot be edited or
// removed by the user, exactly like the predefined roles' default duties.
const DEFAULT_RESPONSIBILITY = 'Their successor is trained';

const defaultRoles = [
  {
    roleName: 'President',
    roleId: 'default_president',
    roleType: 'executive_role',
    responsibilities: [],
    disabled: true,
    removable: false
  },
  {
    roleName: 'Treasurer',
    roleId: 'default_treasurer',
    roleType: 'executive_role',
    responsibilities: [],
    removable: false
  },
  {
    roleName: 'Secretary',
    roleId: 'default_secretary',
    roleType: 'executive_role',
    responsibilities: [],
    removable: false
  },
  {
    roleName: 'General Member',
    roleType: 'general_member',
    roleId: 'general_member',
    moreThanOne: true,
  }
];
const defaultSigningAuth = ['default_president'];

const generalMeetings = [
  {
    id: 'general_weekly',
    name: 'general_weekly',
    value: 'weekly',
    label: 'Weekly',
    description: 'Once a week'
  },
  {
    id: 'general_biweekly',
    name: 'general_biweekly',
    value: 'biweekly',
    label: 'Bi-weekly',
    description: 'Once every two weeks'
  },
  {
    id: 'general_monthly',
    name: 'general_monthly',
    value: 'monthly',
    label: 'Monthly',
    description: 'Once a month'
  },
  {
    id: 'general_termly',
    name: 'general_termly',
    value: 'termly',
    label: 'Termly',
    description: 'Once a term'
  }
];

const execMeetings = [
  {
    id: 'exec_weekly',
    name: 'exec_weekly',
    value: 'weekly',
    label: 'Weekly',
    description: 'Once a week'
  },
  {
    id: 'exec_biweekly',
    name: 'exec_biweekly',
    value: 'biweekly',
    label: 'Bi-weekly',
    description: 'Once every two weeks'
  },
  {
    id: 'exec_monthly',
    name: 'exec_monthly',
    value: 'monthly',
    label: 'Monthly',
    description: 'Once a month'
  },
  {
    id: 'exec_termly',
    name: 'exec_termly',
    value: 'termly',
    label: 'Termly',
    description: 'Once a term'
  }
];

const clubMemberFeeOptions = [
  { label: 'Club Membership is free', value: 'membership_free', name: 'clubMemberFree', id: 'clubMemberFree', description: 'Membership fees are not mandatory for clubs.' },
  { label: 'Club Membership has a fee', value: 'has_fee', name: 'clubMemberNotFee', id: 'clubMemberNotFee', description: 'The non-refundable membership fee is due no later than one month after the first day of class. A Clubs Manager must pre-approve the payment collection method being used by each club. If a student is joining after the first month of the term, membership is due at the beginning of their first club function.' }
];

export { defaultRoles, defaultSigningAuth, generalMeetings, execMeetings, clubMemberFeeOptions, DEFAULT_RESPONSIBILITY };